import { Identity, ServerResponse } from 'data/types';
import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { Contact } from 'data/contact/contact.types';

export const API_PATH_COLLECTION_FUNCTION_GROUP = '/cf-groups';

export const GO_TO_COLLECTION_FUNCTION_GROUP_LIST = 'GO_TO_COLLECTION_FUNCTION_GROUP_LIST';
export const GET_COLLECTION_FUNCTION_GROUP_LIST = 'GET_COLLECTION_FUNCTION_GROUP_LIST';
export const GET_COLLECTION_FUNCTION_GROUP_LIST_PENDING = 'GET_COLLECTION_FUNCTION_GROUP_LIST_PENDING';
export const GET_COLLECTION_FUNCTION_GROUP_LIST_FULFILLED = 'GET_COLLECTION_FUNCTION_GROUP_LIST_FULFILLED';
export const GET_COLLECTION_FUNCTION_GROUP = 'GET_COLLECTION_FUNCTION_GROUP';
export const GET_COLLECTION_FUNCTION_GROUP_PENDING = 'GET_COLLECTION_FUNCTION_GROUP_PENDING';
export const GET_COLLECTION_FUNCTION_GROUP_FULFILLED = 'GET_COLLECTION_FUNCTION_GROUP_FULFILLED';
export const CREATE_COLLECTION_FUNCTION_GROUP = 'CREATE_COLLECTION_FUNCTION_GROUP';
export const CREATE_COLLECTION_FUNCTION_GROUP_PENDING = 'CREATE_COLLECTION_FUNCTION_GROUP_PENDING';
export const CREATE_COLLECTION_FUNCTION_GROUP_FULFILLED = 'CREATE_COLLECTION_FUNCTION_GROUP_FULFILLED';
export const CREATE_COLLECTION_FUNCTION_GROUP_REJECTED = 'CREATE_COLLECTION_FUNCTION_GROUP_REJECTED';
export const UPDATE_COLLECTION_FUNCTION_GROUP = 'UPDATE_COLLECTION_FUNCTION_GROUP';
export const UPDATE_COLLECTION_FUNCTION_GROUP_FULFILLED = 'UPDATE_COLLECTION_FUNCTION_GROUP_FULFILLED';
export const UPDATE_COLLECTION_FUNCTION_GROUP_REJECTED = 'UPDATE_COLLECTION_FUNCTION_GROUP_REJECTED';
export const DELETE_COLLECTION_FUNCTION_GROUP = 'DELETE_COLLECTION_FUNCTION_GROUP';
export const DELETE_COLLECTION_FUNCTION_GROUP_FULFILLED = 'DELETE_COLLECTION_FUNCTION_GROUP_FULFILLED';
export const DELETE_COLLECTION_FUNCTION_GROUP_REJECTED = 'DELETE_COLLECTION_FUNCTION_GROUP_REJECTED';
export const SELECT_COLLECTION_FUNCTION_GROUP = 'SELECT_COLLECTION_FUNCTION_GROUP';

export const OPEN_COLLECTION_FUNCTION_GROUP_CREATE_PAGE = 'OPEN_COLLECTION_FUNCTION_GROUP_CREATE_PAGE';
export const CLOSE_COLLECTION_FUNCTION_GROUP_CREATE_PAGE = 'CLOSE_COLLECTION_FUNCTION_GROUP_CREATE_PAGE';
export const OPEN_COLLECTION_FUNCTION_GROUP_EDIT_PAGE = 'OPEN_COLLECTION_FUNCTION_GROUP_EDIT_PAGE';
export const CLOSE_COLLECTION_FUNCTION_GROUP_EDIT_PAGE = 'CLOSE_COLLECTION_FUNCTION_GROUP_EDIT_PAGE';
export const SET_COLLECTION_FUNCTION_GROUP_LOADING = 'SET_COLLECTION_FUNCTION_GROUP_LOADING';
export const GO_TO_COLLECTION_FUNCTION_GROUP_VIEW = 'GO_TO_COLLECTION_FUNCTION_GROUP_VIEW';

export enum CollectionFunctionGroupPrivileges {
  View = 'cf_view',
  Edit = 'cf_write',
  Delete = 'cf_delete',
}

export type CollectionFunctionGroup = {
  id: string
  name: string
  dxOwner?: string
  dxAccess?: string
  contact?: Contact
  description: string
  cfs: Identity[]
  /** HI-1 sender this LEA receives e-warrants from. Matches EWarrantAuthorisation.SENDERID. */
  hi1endpointid?: string
  hi1notifyuri?: string
  hi1notifysecid?: string
}

/** contact is the select field's id string here, not the {id, name} object it submits as. */
export interface CollectionFunctionGroupFormData extends Omit<CollectionFunctionGroup, 'contact'> {
  contact?: string
}

export type CollectionFunctionGroupGridData = {
  id: string
  parentId: string
  name: string
  description: string
  collectionFunction: string
}

export interface CollectionFunctionGroupState {
  entities: CollectionFunctionGroup[]
  single: CollectionFunctionGroup | null
  selected: CollectionFunctionGroup[]
  createdId: string | null
  ui: CollectionFunctionGroupUIState
}

export type CollectionFunctionGroupUIState = {
  isCreatePopupOpen: boolean
  isEditPopupOpen: boolean
  isLoading: boolean
}

export interface GoToCollectionFunctionGroupListAction extends AnyAction {
  type: typeof GO_TO_COLLECTION_FUNCTION_GROUP_LIST
}

export interface openCollectionFunctionGroupCreatePageAction extends AnyAction {
  type: typeof OPEN_COLLECTION_FUNCTION_GROUP_CREATE_PAGE
}

export interface closeCollectionFunctionGroupCreatePageAction extends AnyAction {
  type: typeof CLOSE_COLLECTION_FUNCTION_GROUP_CREATE_PAGE
}

export interface openCollectionFunctionGroupEditPageAction extends AnyAction {
  type: typeof OPEN_COLLECTION_FUNCTION_GROUP_EDIT_PAGE
}

export interface closeCollectionFunctionGroupEditPageAction extends AnyAction {
  type: typeof CLOSE_COLLECTION_FUNCTION_GROUP_EDIT_PAGE
}

export interface SetCollectionFunctionGroupLoadingAction extends AnyAction {
  type: typeof SET_COLLECTION_FUNCTION_GROUP_LOADING
  payload: { isLoading: boolean }
}

export interface GetCollectionFunctionGroupListAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP_LIST
  payload: AxiosPromise<ServerResponse<CollectionFunctionGroup>>
}

export interface GetCollectionFunctionGroupListPendingAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP_LIST_PENDING
  payload: null
}

export interface GetCollectionFunctionGroupListFulfilledAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface GetCollectionFunctionGroupAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP
  payload: AxiosPromise<ServerResponse<CollectionFunctionGroup>>
}

export interface GetCollectionFunctionGroupPendingAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP_PENDING
  payload: null
}

export interface GetCollectionFunctionGroupFulfilledAction extends AnyAction {
  type: typeof GET_COLLECTION_FUNCTION_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface CreateCollectionFunctionGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateCollectionFunctionGroupAction extends AnyAction {
  type: typeof CREATE_COLLECTION_FUNCTION_GROUP
  payload: AxiosPromise<ServerResponse<CollectionFunctionGroup>>
}

export interface CreateCollectionFunctionGroupPendingAction extends AnyAction {
  type: typeof CREATE_COLLECTION_FUNCTION_GROUP_PENDING
  payload: null
}

export interface CreateCollectionFunctionGroupFulfilledAction extends AnyAction {
  type: typeof CREATE_COLLECTION_FUNCTION_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface CreateCollectionFunctionGroupRejectedAction extends AnyAction {
  type: typeof CREATE_COLLECTION_FUNCTION_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface UpdateCollectionFunctionGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateCollectionFunctionGroupAction extends AnyAction {
  type: typeof UPDATE_COLLECTION_FUNCTION_GROUP
  payload: AxiosPromise<ServerResponse<CollectionFunctionGroup>>
}

export interface UpdateCollectionFunctionGroupFulfilledAction extends AnyAction {
  type: typeof UPDATE_COLLECTION_FUNCTION_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface UpdateCollectionFunctionGroupRejectedAction extends AnyAction {
  type: typeof UPDATE_COLLECTION_FUNCTION_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface DeleteCollectionFunctionGroupThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteCollectionFunctionGroupAction extends AnyAction {
  type: typeof DELETE_COLLECTION_FUNCTION_GROUP
  payload: AxiosPromise<ServerResponse<CollectionFunctionGroup>>
}

export interface DeleteCollectionFunctionGroupFulfilledAction extends AnyAction {
  type: typeof DELETE_COLLECTION_FUNCTION_GROUP_FULFILLED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface DeleteCollectionFunctionGroupRejectedAction extends AnyAction {
  type: typeof DELETE_COLLECTION_FUNCTION_GROUP_REJECTED
  payload: AxiosResponse<ServerResponse<CollectionFunctionGroup>>
}

export interface SelectCollectionFunctionGroupAction extends AnyAction{
  type: typeof SELECT_COLLECTION_FUNCTION_GROUP
  payload: CollectionFunctionGroup[]
}

export interface GoToCollectionFunctionGroupView extends AnyAction{
  type: typeof GO_TO_COLLECTION_FUNCTION_GROUP_VIEW
}

export type CollectionFunctionGroupActionTypes =
  GoToCollectionFunctionGroupListAction |
  openCollectionFunctionGroupCreatePageAction |
  closeCollectionFunctionGroupCreatePageAction |
  openCollectionFunctionGroupEditPageAction |
  closeCollectionFunctionGroupEditPageAction |
  SetCollectionFunctionGroupLoadingAction |
  GetCollectionFunctionGroupListAction |
  GetCollectionFunctionGroupListPendingAction |
  GetCollectionFunctionGroupListFulfilledAction |
  GetCollectionFunctionGroupAction |
  GetCollectionFunctionGroupPendingAction |
  GetCollectionFunctionGroupFulfilledAction |
  CreateCollectionFunctionGroupAction |
  CreateCollectionFunctionGroupPendingAction |
  CreateCollectionFunctionGroupFulfilledAction |
  CreateCollectionFunctionGroupRejectedAction |
  UpdateCollectionFunctionGroupAction |
  UpdateCollectionFunctionGroupFulfilledAction |
  UpdateCollectionFunctionGroupRejectedAction |
  DeleteCollectionFunctionGroupAction |
  DeleteCollectionFunctionGroupFulfilledAction |
  DeleteCollectionFunctionGroupRejectedAction |
  SelectCollectionFunctionGroupAction |
  GoToCollectionFunctionGroupView;
